const ServicioObjetos = {

    asignarAtributosObjeto(event, _this, toUpperCase) {
      let nombrePropiedad = event.target.name;
      let valorPropiedad = event.target.value;
      if (toUpperCase) {
        if (valorPropiedad && typeof valorPropiedad !== 'object')
          valorPropiedad = valorPropiedad.toUpperCase();
      }
  
      let nombreObjetoState = nombrePropiedad.split(".")[0];
      let nombreAtributoObjetoState = nombrePropiedad.split(".")[1];
      let objeto = _this.state[nombreObjetoState];
      objeto[nombreAtributoObjetoState] = valorPropiedad;
      _this.setState({ objeto });
    },
  
    esObjetoVacio(objeto) {
      if (objeto === undefined)
        return true;
      if (objeto === null)
        return true;
      if (objeto.length > 0)
        return false;
      if (objeto.length === 0)
        return true;
      if (objeto === true)
        return false;
      if(Object.keys(objeto).length > 0)
        return false;
      for (var key in objeto) {
        if (hasOwnProperty.call(objeto, key))
          return false;
      }
      return true;
    }
  }
  
  export default ServicioObjetos;